import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Moment } from "moment";
import { ReqType } from "../components/CustomCalendarTimeKeeping/components/ArrivingLateLeavingEarly";

export enum TypeSelect {
  SHORT_TERM = "SHORT_TERM",
  LONG_TERM = "LONG_TERM",
}

export interface DetailInterface {
  allowDuplicate?: boolean;
  reasonCode: string;
  minuteAmount: string;
  reasonName?: string;
  fromDate: Moment;
  toDate: Moment;
  id?: string;
  isNew?: boolean;
  defaultSelected?: ReqType | "";
  type?: ReqType;
  leaveType?: string;
  typeReq?: ReqType | string;
}

export interface FormInterface {
  approveCode: string;
  approveName?: string;
  details: DetailInterface[];
  note: string;
  relatedPersonCodes: string[];
  type: TypeSelect;
  id?: string;
}

interface InitialState {
  data: FormInterface;
  longTerm: {
    fromDate: Moment | null;
    toDate: Moment | null;
    time: number | null;
    typeReq: string;
    reason: string;
    type?: ReqType;
  };
}

const initialState: InitialState = {
  data: {
    details: [],
    approveCode: "",
    note: "",
    relatedPersonCodes: [],
    type: TypeSelect.SHORT_TERM,
    approveName: "",
  },
  longTerm: {
    fromDate: null,
    toDate: null,
    time: null,
    typeReq: null,
    reason: "",
  },
};

const formReqArrivingLateLeaveEarlySlice = createSlice({
  name: "formReqArrivingLateLeaveEarly",
  initialState,
  reducers: {
    formReqArrivingLateLeaveEarlyUpdate: (state, action) => {
      Object.assign(state.data, action.payload);
    },
    formReqUpdateDetailFormArriveLate: (state, action) => {
      state.data = {
        ...state.data,
        details: [...action.payload],
      };
    },
    formReqLongTermUpdate: (
      state,
      action: PayloadAction<InitialState["longTerm"]>
    ) => {
      state.longTerm = { ...state.longTerm, ...action.payload };
    },
    resetFormLongTerm: (state) => {
      state.longTerm = initialState.longTerm;
    },
    formReqArrivingLateLeaveEarlyReset: () => {
      return { ...initialState };
    },
  },
});

export const {
  formReqArrivingLateLeaveEarlyUpdate,
  formReqArrivingLateLeaveEarlyReset,
  formReqLongTermUpdate,
  resetFormLongTerm,
  formReqUpdateDetailFormArriveLate,
} = formReqArrivingLateLeaveEarlySlice.actions;

export default formReqArrivingLateLeaveEarlySlice.reducer;
